<script lang="ts" setup>
import PhIcon from '../PhIcon.vue'
import LabelBase from '../label/LabelBase.vue'

type ErrorType = 'error' | 'notFound'

defineProps<{
  type: ErrorType
}>()

const title: Record<ErrorType, string> = {
  error: 'Server Error',
  notFound: 'Not Found',
}

const message: Record<ErrorType, string> = {
  error: 'Ada masalah server, silakan hubungi tim terkait',
  notFound: 'Data tidak ditemukan, silakan cek kembali data dengan benar',
}

const icon: Record<ErrorType, string> = {
  error: 'cactus',
  notFound: 'cactus',
}
</script>

<template>
  <div class="flex w-full h-1/2">
    <div class="mx-auto my-auto text-center">
      <ph-icon :name="icon[type]" :size="64" class="mx-auto block mb-2"></ph-icon>
      <label-base class="block font-bold" size="xl">{{ title[type] }}</label-base>
      <label-base class="block" color="stone">{{ message[type] }}</label-base>
    </div>
  </div>
</template>
